export const weekdaysLocaleDict = {
    ru: {
        mon: 'Пн',
        tue: 'Вт',
        wed: 'Ср',
        thu: 'Чт',
        fri: 'Пт',
        sat: 'Сб',
        sun: 'Вс'
    },
    en: {
        mon: 'Mo',
        tue: 'Tu',
        wed: 'We',
        thu: 'Th',
        fri: 'Fr',
        sat: 'Sa',
        sun: 'Su'
    },
    th: {
        mon: 'จ',
        tue: 'อ',
        wed: 'พ',
        thu: 'พฤ',
        fri: 'ศ',
        sat: 'ส',
        sun: 'อา'
    },
    tr: {
        mon: 'Pt',
        tue: 'Sa',
        wed: 'Ça',
        thu: 'Pe',
        fri: 'Cu',
        sat: 'Ct',
        sun: 'Pz'
    }
};

